import StopWatchIcon from 'components/ReusableComponents/Icons/StopWatch'

import styles from './ResponseTime.module.scss'

const ResponseTime = ({ value, isLoading }) => (
  <div className={styles.wrapper}>
    {!isLoading && (
      <>
        <StopWatchIcon className={styles.icon} />
        <div>
          <p className={styles.title}>Average response time</p>
          <p className={styles.bigNumber}>{value}</p>
        </div>
      </>
    )}
  </div>
)

export default ResponseTime
